import { render, staticRenderFns } from "./custom-company-cooperation.vue?vue&type=template&id=a8cc2642&scoped=true&"
import script from "./custom-company-cooperation.vue?vue&type=script&lang=js&"
export * from "./custom-company-cooperation.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-cooperation.vue?vue&type=style&index=0&id=a8cc2642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cc2642",
  null
  
)

export default component.exports